import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IInbox, Inbox } from "@/models/inbox.entity";

export const InboxDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IInbox> {
  protected mapEntity(entity: IInbox): IInbox {
    return new Inbox(entity);
  }

  getIdentifier(entity: IInbox): string {
    return entity.id;
  }

  mapsConfig = {};
})();
